import styled from "styled-components"

export const UserLogoWrapper = styled.div<{
    height: number
    systemInactive?: boolean
    projectInactive?: boolean
}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    max-width: 100%;
    padding: 2px 0;
    cursor: default;

    span {
        line-height: ${(props) => props.height}px;
        color: ${(props) => {
        if (props.systemInactive) return props.theme.userIconSystemInactiveColor
        if (props.projectInactive) return props.theme.userIconProjectInactiveColor
        return props.theme.userIconTextColor
    }};
    }

    img {
        border: ${(props) => {
        if (props.systemInactive) return `3px solid ${props.theme.userIconSystemInactiveColor}`
        if (props.projectInactive) return `3px solid ${props.theme.userIconProjectInactiveColor}`
        return "none"
    }};
    }
`
export const UserName = styled.span`
    margin-left: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: ${(props) => props.theme.fontSizes.sm}px;
`
